<template>
  <a-layout style="min-height: 100vh">
    <a-layout-sider v-model:collapsed="collapsed" collapsible>
      <div class="logo">
        <img src="../assets/logo.png" alt="logo" />
        <span v-if="!collapsed">龙顽堂</span>
      </div>
      <a-menu v-model:selectedKeys="selectedKeys" theme="dark" mode="inline">
        <a-menu-item key="user" @click="navigateTo('user')">
          <desktop-outlined />
          <span>用户管理</span>
        </a-menu-item>
        <a-menu-item key="main" @click="navigateTo('image')">
          <pie-chart-outlined />
          <span>图片管理</span>
        </a-menu-item>
        <a-menu-item key="product" @click="navigateTo('product')">
          <appstore-outlined />
          <span>商品管理</span>
        </a-menu-item>
        <a-menu-item key="video" @click="navigateTo('video')">
          <video-camera-outlined />
          <span>视频管理</span>
        </a-menu-item>
        <a-menu-item key="pdf" @click="navigateTo('pdf')">
          <file-outlined />
          <span>PDF管理</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0 16px; display: flex; justify-content: space-between; align-items: center;">
        <div class="header-trigger">
          <menu-unfold-outlined v-if="collapsed" class="trigger" @click="() => (collapsed = !collapsed)" />
          <menu-fold-outlined v-else class="trigger" @click="() => (collapsed = !collapsed)" />
        </div>
        <div class="header-right">
          <a-dropdown>
            <a class="ant-dropdown-link" @click.prevent>
              <a-avatar icon="user" style="margin-right: 8px" />
              管理员
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <a href="javascript:;">个人中心</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" @click="handleLogout">退出登录</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </a-layout-header>
      <a-layout-content style="margin: 0 16px">
        <a-breadcrumb style="margin: 16px 0">
          <a-breadcrumb-item>首页</a-breadcrumb-item>
        </a-breadcrumb>
        <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
          <router-view />
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center">
        Longwantang Admin ©2025 Created by Ant UED
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  PieChartOutlined,
  DesktopOutlined,
  UserOutlined,
  TeamOutlined,
  FileOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  ShoppingOutlined,
  AppstoreOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

const collapsed = ref(false);
const router = useRouter();
const route = useRoute();
const selectedKeys = ref([route.name || 'user']);

const navigateTo = (name) => {
  router.push({ name });
};

watch(
  () => route.name,
  (val) => {
    if (val) selectedKeys.value = [val];
  }
);

const handleLogout = () => {
  // 清除token
  localStorage.removeItem('token');
  message.success('退出成功');
  router.push('/login');
};
</script>

<style scoped>
.logo {
  height: 48px;
  margin: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.logo img {
  height: 50px;
}

.logo span {
  color: white;
  font-size: 20px;
  font-weight: bold;
  margin-left: 8px;
  white-space: nowrap;
}

.trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.trigger:hover {
  color: #1890ff;
}

.header-right {
  margin-right: 24px;
}

.site-layout .site-layout-background {
  background: #fff;
}
</style>
